// Copyright (c) 2020 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import {connect} from 'react-redux'

import AddForm from './AddForm'
import ItemInfo from './ItemInfo'
import TableHeaders from './Headers'

import {checkItems, showAddForm} from '../../actions/table'

import PersonAddOutlinedIcon from '@material-ui/icons/PersonAddOutlined'

import './index.css'

class Table extends Component {
  showEditForm = (formNumber = 0) => {
    this.setState({editing: formNumber})
    this.setState({adding: false})
  }

  showAddForm = () => {
    this.setState({adding: !this.state.adding})
    this.setState({editing: 0})
  }

  renderTableContent = () => {
    const {items,
      updateFields,
      validateUpdate,
      onUpdateSubmit,
      infoFields,
      updateButtons,
      checkBoxes,
      editing,
      editEnabled} = this.props

    let formNumber = 0

    if (!items || !items.map) {
      return null
    }

    let forms = items.map((item) => {
      formNumber = formNumber + 1
      let formName = `${formNumber}`

      return (
        <ItemInfo
          item={item}
          formName={formName}
          key={formNumber}
          formNumber={formNumber}
          updateFields={updateFields}
          infoFields={infoFields}
          validate={validateUpdate}
          onSubmit={onUpdateSubmit}
          editing={editing}
          initialValues={item}
          updateButtons={updateButtons}
          checkBoxes={checkBoxes}
          editEnabled={editEnabled}
        />
      )
    })

    return forms
  }

  renderAddForm = () => {
    const {table, showAddForm} = this.props
    const addFormClassName = table.editing === 1 ? 'no-bottom-border' : ''

    return (
      <AddForm
        className={addFormClassName}
        key={'add'}
        validate={this.props.validateAdd}
        fields={this.props.addFields}
        onSubmit={this.props.onAddSubmit}
        addItemText={this.props.addItemText}
        onCancel={showAddForm}
      />
    )
  }

  renderTableHeaders () {
    const {tableHeaders} = this.props
    let headers = tableHeaders.map((header) => {
      return (
        <div className='th col-1'>{header}</div>
      )
    })
    return headers
  }

  renderFloatingMenu () {
    if (this.props.floatingMenuButtons) {
      return (
        <div className='floating-menu'>
          {this.props.floatingMenuButtons}
        </div>
      )
    }

    return null
  }

  renderItemsCount () {
    const {showItemsCount, items} = this.props
    let itemsCount = 0

    if (showItemsCount || !items) {
      if (items)
        itemsCount = Object.keys(items).length

      return (
        <div className='tr padding-30 row item-count'>
          <div className='td col'>
            <span>{itemsCount} results</span>
          </div>
        </div>
      )
    }
  }

  renderTable () {
    const {table, showAddForm, addFields} = this.props
    const {tableHeaders, addItemText, checkBoxes, handleHeaderSubmit} = this.props
    const {adding} = table
    const addClassName = table.editing === 1 || adding === true ? 'no-bottom-border' : ''
    const pinkBackground = this.props.pinkBackground === false ? '' : 'pink-background'

    return (
      <div className='table table-borderless row'>
        <div className={`thead col-md-12 ${pinkBackground}`}>
          <div className='tr row table-headers'>
            <TableHeaders tableHeaders={tableHeaders} checkBoxes={checkBoxes} handleSubmit={handleHeaderSubmit}/>
          </div>
        </div>
        <div className='tbody col-12'>
          {addFields &&
          <div className={`tr add-buttons padding-30 row ${addClassName}`}>
            <div className='th col-1' onClick={showAddForm}><PersonAddOutlinedIcon className='pointer'/></div>
            <div className='td col-2'><span className='pointer' onClick={showAddForm}>{addItemText}</span></div>
          </div>
          }
          {adding &&
          this.renderAddForm()
          }
          {this.renderItemsCount()}
          {this.renderTableContent()}
        </div>
      </div>
    )
  }

  render () {
    return (
      <div className='align-items-center'>
        <div className='table'>
          {this.renderTable()}
          {this.renderFloatingMenu()}
        </div>
      </div>
    )
  }
}


function mapStateToProps ({table}) {
  return {table}
}

export default connect(mapStateToProps, {checkItems, showAddForm})(Table)
